import * as tslib_1 from "tslib";
import { NgZone } from '@angular/core';
import animateScrollTo from 'animated-scroll-to';
import { Router, Scroll } from '@angular/router';
import { takeUntil, filter, map } from 'rxjs/operators';
import { Destroyer, sleep } from '@apps/tools';
import { WindowRef } from './window.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "./window.service";
import * as i3 from "@angular/common";
const ɵ0 = t => {
    return t;
}, ɵ1 = t => {
    return t * t;
}, ɵ2 = t => {
    return t * (2 - t);
}, ɵ3 = t => {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
}, ɵ4 = t => {
    return t * t * t;
}, ɵ5 = t => {
    return --t * t * t + 1;
}, ɵ6 = t => {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
}, ɵ7 = t => {
    return t * t * t * t;
}, ɵ8 = t => {
    return 1 - --t * t * t * t;
}, ɵ9 = t => {
    return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
}, ɵ10 = t => {
    return t * t * t * t * t;
}, ɵ11 = t => {
    return 1 + --t * t * t * t * t;
}, ɵ12 = t => {
    return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
};
/*
 * Easing Functions
 * https://gist.github.com/gre/1650294
 */
export const EasingFunctions = {
    // no easing, no acceleration
    linear: ɵ0,
    // accelerating from zero velocity
    easeInQuad: ɵ1,
    // decelerating to zero velocity
    easeOutQuad: ɵ2,
    // acceleration until halfway, then deceleration
    easeInOutQuad: ɵ3,
    // accelerating from zero velocity
    easeInCubic: ɵ4,
    // decelerating to zero velocity
    easeOutCubic: ɵ5,
    // acceleration until halfway, then deceleration
    easeInOutCubic: ɵ6,
    // accelerating from zero velocity
    easeInQuart: ɵ7,
    // decelerating to zero velocity
    easeOutQuart: ɵ8,
    // acceleration until halfway, then deceleration
    easeInOutQuart: ɵ9,
    // accelerating from zero velocity
    easeInQuint: ɵ10,
    // decelerating to zero velocity
    easeOutQuint: ɵ11,
    // acceleration until halfway, then deceleration
    easeInOutQuint: ɵ12
};
const repeatsLimit = 5;
const scrollOptions = {
    maxDuration: 3000,
    minDuration: 250,
    speed: 500,
    easing: EasingFunctions.easeInOutQuint
};
const getQueryParam = (name, url) => {
    const urlParams = new URLSearchParams(url || window.location.search);
    return urlParams.get(name);
};
const ɵ13 = getQueryParam;
export class ScrollService extends Destroyer {
    constructor(router, ngZone, winRef, document) {
        super();
        this.router = router;
        this.ngZone = ngZone;
        this.winRef = winRef;
        this.document = document;
        this.counter = 0;
    }
    initRouterScroll() {
        this.router.events
            .pipe(takeUntil(this.destroy$), filter(e => e instanceof Scroll), map((e) => ({ anchor: e.anchor, first: e.routerEvent.id === 1 })))
            .subscribe(({ anchor, first }) => {
            if (!anchor) {
                this.scrollTop();
            }
            else {
                this.scrollToElement(`#${anchor}`, first ? 500 : 200, {
                    verticalOffset: this.getFixedMenuOffset()
                });
            }
        });
    }
    scrollTop(behavior = 'auto') {
        this._scrollToTop(behavior);
    }
    scrollToElement(element, delay = 0, options = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (delay > 0) {
                yield sleep(delay);
            }
            if (typeof element === 'string') {
                element = document.querySelector(element);
            }
            if (element) {
                this.counter = 0;
                return yield this._scrollToElement(element, options);
            }
            else if (this.counter < repeatsLimit) {
                this.counter++;
                clearTimeout(this.timer);
                this.ngZone.runOutsideAngular(() => {
                    this.timer = setTimeout(() => {
                        this.scrollToElement(element, 0, options);
                    }, 500);
                });
            }
            else {
                this.counter = 0;
                return false;
            }
        });
    }
    scrollByQueryParams(offset, url) {
        const params = (getQueryParam('scroll', url) || '').split(',');
        let element;
        let param;
        for (const p of params) {
            element = document.querySelector(`[data-id="${p}"]`);
            param = p;
            if (element) {
                break;
            }
        }
        this.scrollToElement(element, 500, {
            verticalOffset: offset || 0,
            speed: 800,
            easing: EasingFunctions.easeInOutCubic
        });
        return param;
    }
    _scrollToTop(behavior) {
        if (this.winRef.nativeWindow.scrollTo) {
            this.winRef.nativeWindow.scrollTo({
                top: 0,
                behavior
            });
        }
    }
    _scrollToElement(element, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const bodyRect = document.body.getBoundingClientRect().top;
            const elementRect = element.getBoundingClientRect().top;
            const elementPosition = elementRect - bodyRect;
            yield animateScrollTo(elementPosition, Object.assign(scrollOptions, options));
        });
    }
    getFixedMenuOffset() {
        const isFixed = this.document.body.classList.contains('menu-fixed');
        return isFixed ? -50 : 0;
    }
}
ScrollService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ScrollService_Factory() { return new ScrollService(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(i2.WindowRef), i0.ɵɵinject(i3.DOCUMENT)); }, token: ScrollService, providedIn: "root" });
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13 };
